// src/utils/taglines.ts
// Random taglines for Cubemate homepage

const TAGLINES = [
  "Learn. Execute. Master.",
  "Code in any language. Learn at your pace.",
  "Your AI-powered coding lab.",
  "Write, run, and learn — all in one place.",
  "The coding platform that teaches while you build.",
  "Instant code execution. Guided learning. Real projects.",
  "Where coding practice meets AI mentorship.",
  "Code smarter. Learn faster. Build more.",
];

/**
 * Get a random tagline
 * Returns the same tagline for the entire session (uses sessionStorage)
 */
export const getRandomTagline = (): string => {
  // Check if we already have a tagline for this session
  const sessionTagline = sessionStorage.getItem('cubemate-tagline');

  if (sessionTagline) {
    return sessionTagline;
  }

  // Generate a new random tagline
  const randomIndex = Math.floor(Math.random() * TAGLINES.length);
  const tagline = TAGLINES[randomIndex];

  // Store it for this session
  sessionStorage.setItem('cubemate-tagline', tagline);

  return tagline;
};

/**
 * Clear the stored tagline (for testing)
 */
export const clearTagline = (): void => {
  sessionStorage.removeItem('cubemate-tagline');
};
